import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { Database, Code, Laptop, CheckCircle2 } from 'lucide-react';

const Services = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const services = [
    {
      icon: Database,
      title: t.services.data.title,
      desc: t.services.data.desc,
      items: t.services.data.items
    },
    {
      icon: Code,
      title: t.services.web.title,
      desc: t.services.web.desc,
      items: t.services.web.items
    },
    {
      icon: Laptop,
      title: t.services.consulting.title,
      desc: t.services.consulting.desc,
      items: t.services.consulting.items
    }
  ];

  return (
    <section id="services" className="brutalist-section">
      <div className="brutalist-container">
        <div data-reveal="out" className="grid md:grid-cols-[0.9fr_1.1fr] gap-10 items-start">
          <div>
            <p className="brutalist-kicker">{t.services.title}</p>
            <h2 className="brutalist-title mt-4">{t.services.subtitle}</h2>
          </div>

          <div className="space-y-6">
            {services.map((service, index) => {
              const Icon = service.icon;
              return (
                <div
                  key={index}
                  data-reveal="out"
                  style={{ '--reveal-delay': `${index * 70}ms` }}
                  className="brutalist-card p-6 transition-colors duration-100 ease-linear hover:bg-muted hover:border-accent"
                >
                  <div className="flex items-start gap-4">
                    <div className="h-12 w-12 border border-foreground bg-accent text-accent-foreground flex items-center justify-center flex-shrink-0">
                      <Icon className="w-6 h-6" />
                    </div>

                    <div className="min-w-0">
                      <h3 className="font-mono tracking-[0.08em] text-xl font-semibold">
                        {service.title}
                      </h3>
                      <p className="mt-3 text-muted-foreground leading-relaxed">
                        {service.desc}
                      </p>

                      <ul className="mt-5 space-y-2">
                        {service.items.map((item, idx) => (
                          <li key={idx} className="flex items-start text-sm leading-relaxed">
                            <CheckCircle2 className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
